module.exports = __webpack_public_path__ + "static/img/005城市名片5.00da025.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/005城市名片5.jpg
// module id = cim8
// module chunks = 0